export default __webpack_public_path__ + "static/media/bg_big_grey.c5a3aa7e.svg";